import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useSendMessageToTeamPageStyles = makeStyles({
    root: {
        ...shorthands.padding('1rem', tokens.spacingHorizontalXXXL),
        alignSelf: 'flex-start',
        justifyItems: 'start',
        justifyContent: 'space-evenly',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
    },
    actions: {
        marginTop: 'auto',
        alignSelf: 'end',
        display: 'flex',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalS,
    },
    formField: {
        display: 'flex',
        flexDirection: 'column',
        '& > label': {
            marginBottom: tokens.spacingVerticalMNudge,
        },
    },
    textArea: {
        // '> textarea': {
        //     height: '80px',
        // },
    },
    warning: {
        color: tokens.colorNeutralForeground3,
    },
    error: {
        color: tokens.colorStatusDangerForeground3,
    },
});
